module.exports = __webpack_public_path__ + "img/smoked-burger.b176ffc9.jpg";